import { api } from '@/api/api';
export class AgcOpApiImpl {
    constructor() {
        this.name = 'agcOpApiImpl';
        this.http = api.getDataTransApi();
        this.eventApi = api.getEventApi();
        this.systemApi = api.getSystemApi();
    }
    init() {
        return this.name;
    }
    errorHandler(error) {
        var _a;
        this.eventApi.sendSysEvent({
            auto: true,
            eventSeq: 0,
            eventName: 'error',
            eventLevel: 'error',
            eventData: {
                title: ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.message) || (error === null || error === void 0 ? void 0 : error.message) || '网络错误',
                content: '',
                popupType: 'toast',
                popupLevel: 'error',
            },
        });
    }
    async get(url, req, config) {
        try {
            const { data } = await this.http.get(url, req, config);
            if (!data)
                throw {};
            if (!data.success) {
                throw data;
            }
            return data.data;
        }
        catch (error) {
            const { toastError = true } = config || {};
            toastError && this.errorHandler(error);
            return Promise.reject(error);
        }
    }
    async post(url, body, config) {
        config = Object.assign({ contentType: 'json', noEnqueue: false }, (config || {}));
        try {
            const { data } = await this.http.post(url, body, config);
            if (!data)
                throw {};
            if (!data.success) {
                throw data;
            }
            return data.data;
        }
        catch (error) {
            const { toastError = true } = config || {};
            toastError && this.errorHandler(error);
            return Promise.reject(error);
        }
    }
    async delete(url, req, config) {
        try {
            const { data } = await this.http.delete(url, req, config);
            if (!data)
                throw {};
            if (!data.success) {
                throw data;
            }
            return data.data;
        }
        catch (error) {
            const { toastError = true } = config || {};
            toastError && this.errorHandler(error);
            return Promise.reject(error);
        }
    }
    getFbIsBindAdAccount() {
        return this.get(this.systemApi.getUrl('getAgcOpFbIsBindAdAccount'));
    }
    getFbAds() {
        return this.get(this.systemApi.getUrl('getAgcOpFbAds'));
    }
    getFbAdsEffectOverall(req) {
        return this.post(this.systemApi.getUrl('getAgcOpFbAdsEffectOverall'), req);
    }
    getFbAdsStats() {
        return this.get(this.systemApi.getUrl('getAgcOpFbAdsStats'));
    }
    getFbAdsLeadsStats() {
        return this.get(this.systemApi.getUrl('getAgcOpFbAdsLeadsStats'));
    }
    getFbAdsLeadsList(req) {
        return this.post(this.systemApi.getUrl('getAgcOpFbAdsLeadsList'), req);
    }
    getFbAdsLeadsDetail(req) {
        return this.get(this.systemApi.getUrl('getAgcOpFbAdsLeadsDetail'), req);
    }
    markFbAdsLeads(req) {
        return this.get(this.systemApi.getUrl('markAgcOpFbAdsLeads'), req);
    }
    getCrmLeadsOpenIdByPrivateId(req) {
        return this.post(this.systemApi.getUrl('getCrmLeadsOpenIdByPrivateId'), req);
    }
    exportFbLeads(req) {
        return this.http.post(this.systemApi.getUrl('exportFbLeads'), req, { contentType: 'json', responseType: 'blob' });
    }
}
const agcOpApi = new AgcOpApiImpl();
api.registerLogicalApi(agcOpApi);
export default agcOpApi;
